// Nikolai Genov: language-independent facts plus one profile file per language.
module.exports = {
  slug: 'nikolai-genov',
  displayName: 'Nikolai Genov',
  name: 'Dr. Nikolai N. Genov',
  // Shown as the row "Website" on the profile page and in the PDF.
  links: [
    { text: 'leap-dynamics.com', url: 'https://leap-dynamics.com' }
  ],
  pdf: {
    firstName: 'Nikolai N.',
    familyName: 'Genov',
    email: 'info@paioneer.eu',
    homepage: 'paioneer-labs.eu'
  },
  pages: {
    de: require('./de.cjs'),
    en: require('./en.cjs'),
    nl: require('./nl.cjs'),
    uk: require('./uk.cjs'),
    fr: require('./fr.cjs'),
    it: require('./it.cjs'),
    es: require('./es.cjs'),
    sv: require('./sv.cjs'),
    fi: require('./fi.cjs'),
    ja: require('./ja.cjs'),
    pl: require('./pl.cjs'),
    bg: require('./bg.cjs')
  }
};
